import { get as getDeviceId } from './fingerprintManager.js';

/**
 * Generates a composite user ID by combining the base user ID with a device fingerprint.
 * This ensures unique identification for both rate limiting and analytics purposes.
 * 
 * Note: fingerprintManager now guarantees a fingerprint is always generated (never null),
 * so we can safely append it without a conditional check.
 * 
 * @param {string} baseUserId - The base user ID (e.g., "adweek.com")
 * @returns {Promise<string>} The composite user ID (e.g., "adweek.com_123456789")
 */
export async function getCompositeUserId(baseUserId) {
  if (!baseUserId) {
    return baseUserId;
  }
  
  const fingerprint = await getDeviceId();
  return `${baseUserId}_${fingerprint}`;
} 